import FactorSensitivityChart from './FactorSensitivityChart';

export default FactorSensitivityChart;
